import { useIntl } from "react-intl";

import Button from "../../components/button/Button";

import { ReactComponent as EconomySVG } from "../../assets/info_screen-economy.svg";
import { ReactComponent as FuseSVG } from "../../assets/info_screen-fuse.svg";
import { ReactComponent as ImportantNoteSVG } from "../../assets/info_screen-important-note.svg";
import { ReactComponent as OverviewSVG } from "../../assets/info_screen-overview.svg";
import { ReactComponent as PerfectSVG } from "../../assets/info_screen-perfect.svg";

import { ReactComponent as CheckboxCheckedSVG } from "../../assets/checkbox-checked.svg";
import { ReactComponent as CheckboxSVG } from "../../assets/checkbox.svg";

function OverviewPage() {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="page-title">
        {formatMessage({ id: "info_screen.overview.page_title" })}
      </div>
      <div className="page-subtitle">
        {formatMessage({ id: "info_screen.overview.page_subtitle" })}
      </div>

      <div className="page-description">
        {formatMessage({ id: "info_screen.overview.page_description" })}
      </div>
      <div className="page-image">
        <OverviewSVG />
      </div>
    </div>
  );
}

function FusePage() {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="page-description">
        {formatMessage({ id: "info_screen.fuse.page_description" })}
      </div>
      <div className="page-image">
        <FuseSVG />
      </div>
    </div>
  );
}

function EconomyPage() {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="page-description">
        {formatMessage({ id: "info_screen.economy.page_description" })}
      </div>
      <div className="page-image">
        <EconomySVG />
      </div>
    </div>
  );
}

function PerfectPage() {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="page-description">
        {formatMessage({ id: "info_screen.perfect.page_description" })}
      </div>
      <div className="page-image">
        <PerfectSVG />
      </div>
    </div>
  );
}

function ImportantNotePage() {
  const { formatMessage } = useIntl();

  return (
    <div>
      <div className="page-description">
        <p className="important">
          {formatMessage({
            id: "info_screen.important_note.page_description.important",
          })}
        </p>
        {formatMessage({
          id: "info_screen.important_note.page_description",
        })}
      </div>
      <div className="page-image">
        <ImportantNoteSVG />
      </div>
    </div>
  );
}

function ShowInstructions({
  value,
  onChange,
}: {
  value: boolean;
  onChange: Function;
}) {
  const { formatMessage } = useIntl();

  return (
    <div className="show-info_screen">
      <div>
        <Button
          className="checkbox"
          onClick={() => onChange(!value)}
          Icon={value ? CheckboxSVG : CheckboxCheckedSVG}
          title={formatMessage({ id: "info_screen.checkbox" })}
        />
      </div>
      <div className="description">
        {formatMessage({ id: "info_screen.checkbox_description" })}
      </div>
    </div>
  );
}

export {
  OverviewPage,
  FusePage,
  EconomyPage,
  PerfectPage,
  ImportantNotePage,
  ShowInstructions,
};
